/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { IoIosArrowDown } from "react-icons/io";

const Section = styled.section`
  border: 0px solid #dadce0;
`;
const ContainerFluid = styled.div`
  min-height: 100vh;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-image: url("/images/GraphicSection_up_stairs.jpeg");
  background-image: url("/images/GraphicSection_jog_shuttle.jpeg");
  background-image: url("/images/GraphicSection_arrow.jpeg");
  background-image: url("/images/GraphicSection_server_two_mod.jpeg");
  background-image: url("/images/GraphicSection_server_one_mod.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 42% 0%;
`;
const ScrollDownDirective = styled.div`
  position: absolute;
  bottom: 9px;
  color: rgb(255, 255, 255);
  left: 50%;
  text-align: center;
  width: 100%;
  z-index: 1;
  transform: translate(-50%, -50%);
  cursor: pointer;
  opacity: 1;
  animation: 1s cubic-bezier(0.7, 0.01, 0, 1) 0.8s 1 normal forwards running bcCCNc;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  line-height: 22px;
`;
const ScrollDownText = styled.p`
  margin: 4px 0px;
`;
class GraphicSection extends Component {
  render() {
    return (
      <div className="GraphicSection">
        <Section>
          <ContainerFluid>
            <ScrollDownDirective>
              <a href="#SectionOne"><ScrollDownText>Scroll Down</ScrollDownText></a>
              <a href="#SectionOne"><IoIosArrowDown/></a>
            </ScrollDownDirective>
          </ContainerFluid>
        </Section>
      </div>
    );
  }
}

export default GraphicSection;
